import React from 'react';
import ApprovalAvatar from './ApprovalAvatar';
require('./ApprovalUnstart.scss');
const Item = props => {
    props.data['hasAvatar'] = true;
    return (<div className="unstart-cell">
                <ApprovalAvatar cls="unstart-icon" info={{ hasAvatar: true, avatar: props.data }} />
                <div className="unstart-text">{props.data.name}</div>
            </div>);
};

const ApprovalUnstart = props => {
    const unstartArr = props.data;
    return (<div className="unstart-container">
                {unstartArr.map((item,index) => {
                    return <Item data={item} key={index} />;
                })}
            </div>);
};

export default ApprovalUnstart;


// WEBPACK FOOTER //
// ./src/components/Approval/new/ApprovalUnstart.js